import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  private readonly STORAGE_KEY = 'sms_cookie_consent';
  private readonly GTM_ID = 'GTM-WSD6PXJG';

  readonly hasDecided = signal(false);
  readonly hasConsented = signal(false);

  constructor() {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored !== null) {
      this.hasDecided.set(true);
      if (stored === 'accepted') {
        this.hasConsented.set(true);
        this.loadGtm();
      }
    }
  }

  accept(): void {
    localStorage.setItem(this.STORAGE_KEY, 'accepted');
    this.hasConsented.set(true);
    this.hasDecided.set(true);
    this.loadGtm();
  }

  decline(): void {
    localStorage.setItem(this.STORAGE_KEY, 'declined');
    this.hasDecided.set(true);
  }

  private loadGtm(): void {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.GTM_ID}`;
    document.head.appendChild(script);
  }
}
